const faq = [
  {
    question: "What is VeRoyalties?",

    answer: "VeRoyalties is an innovative investment project dedicated to real estate. We allow clients to invest as little as €10 in investment properties, with the aim of building up regular income and/or savings."
  },
  {
    question: "I want to buy NFTs, what payment methods are accepted?",

    answer: "In order to invest in our properties, it is necessary to credit your VeChain portfolio (sync, sync2 or VeChainThor) with VeUSD beforehand."
  },
  {
    question: "What is the marketplace, or secondary market?",

    answer: "The VeRoyalties Marketplace is our platform that allows VeRoyalties community members to buy and sell NFTs among themselves.  It is the equivalent of a secondary market where investors can buy and sell NFTs among themselves. We may also cooperate with other marketplaces to allow anyone to choose their preferred marketplace."
  },
  {
    question: "I sell or buy NFTs during the month. Who receives the rental income for the current month?",
    answer: "The rental income is paid to the investor who owns the NFTs on the day the royalties are paid."
  },
  {
    question: "Are transactions on the platform secure?",

    answer: "VeRoyalties uses the most advanced technical means to ensure the confidentiality and security of transactions on the platform. To manage your payment requests, VeRoyalties uses the VeChain blockchain to create smart contracts and manage the secondary market."
  }
]

export default faq;